import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { AppTheme, getDefaultTheme, LayoutBreakpointService } from '@headpower/layout';

/**
 * User Interface service that contains streams for displaying UI consistently across the application.
 */
@Injectable({
    providedIn: 'root'
})
export class UserInterfaceService {

    private mobile: boolean = false;
    private mobileSubject: ReplaySubject<boolean> = new ReplaySubject(1);

    /**
     * Current mobile state
     */
    public get isMobile(): boolean {
        return this.mobile;
    }

    /**
     * Mobile state observable
     */
    public get mobile$(): Observable<boolean> {
        return this.mobileSubject.asObservable();
    }

    constructor(
        private breakpointService: LayoutBreakpointService) {

        this.breakpointService.observer$
            .subscribe(result => this.updateState(result.handset))
    }

    /**
     * Generates a primary toned theme from the default theme.
     * 
     * Used to theme targets e.g. task, worksite etc.
     * 
     * @param name Theme unique name
     * @param tone Theme primary tone
     * @returns Primary toned theme
     */
    public generatePrimaryTonedTheme(name: string, tone: string): AppTheme {
        let theme = getDefaultTheme();

        theme.name = name;

        theme.primary.defaultTones = {
            default: tone,
            darker: tone
        };

        return theme;
    }

    private updateState(handset: boolean): void {
        this.mobile = handset;
        this.mobileSubject.next(handset);
    }
}
